import { formatDate } from '@/helpers/dates';

import { Notification } from '@/api/types';

export type GroupedNotifications = {
  date: string;
  notifications: Notification[];
};

export const TODAY = 'Сьогодні';
const YESTERDAY = 'Вчора';

export const groupNotificationsByDate = (notifications: Notification[]): GroupedNotifications[] => {
  const today = formatDate(new Date());
  const yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
  const yesterday = formatDate(yesterdayDate);

  const groups: Array<{ date: string; notifications: Notification[] }> = [];

  notifications.forEach((n) => {
    const dateStr = formatDate(new Date(n.created_at));
    const date = dateStr === today ? TODAY : dateStr === yesterday ? YESTERDAY : dateStr;

    const lastGroup = groups[groups.length - 1];
    if (lastGroup && lastGroup.date === date) {
      lastGroup.notifications.push(n);
    } else if (date) {
      groups.push({ date, notifications: [n] });
    }
  });

  return groups;
};
